import * as React from 'react';
import ProjectData from 'src/value-objects/ProjectData';
import { baseApiRoute } from 'src/resources/const';
import RichEditContainer from 'src/modules/commons/inputs/rich-edit/RichEdit.container';

export interface ProjectGoToMarketFormComponentProps {
  formData: ProjectData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleRichEditor: (key: string) => (html: string) => void;
}

class ProjectBusinessModelFormComponent extends React.Component<ProjectGoToMarketFormComponentProps> {

  public render(): React.ReactNode {
    return (

      <div>
        <p className="f-s-26">
          Modelo de negocio
        </p>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-md-12">
            <RichEditContainer
              onChange={(value) => this.props.handleRichEditor('goToMarketDescription')(value)}
              placeholder="Añade la descripción del modelo de negocio"
              uploadURL={baseApiRoute + '/save-image'}
              value={this.props.formData.goToMarketDescription}
            />
          </div>
        </div>
        <div className="gap-20"/>
      </div>
    );
  }
}

export default ProjectBusinessModelFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectBusinessModelForm.component.tsx